import React from 'react';
import { Offcanvas } from 'reactstrap';
import { X } from 'react-feather';
import { cx } from './cx';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  /** Accessible name; the visible header is the children's job, so it can hold a profile header. */
  label: string;
  /** md 480px (default), lg 640px. Full width on phones. */
  size?: 'md' | 'lg';
  children?: React.ReactNode;
}

/**
 * A panel that slides in from the right over the page, for looking at one
 * row of a list without leaving it (e.g. a candidate on the hiring board).
 * Use Dialog for forms that need the user's full attention.
 */
const Drawer: React.FC<DrawerProps> = ({ open, onClose, label, size = 'md', children }) => (
  <Offcanvas
    isOpen={open}
    toggle={onClose}
    direction="end"
    className={cx('ds-drawer', size === 'lg' && 'ds-drawer--lg')}
    aria-label={label}
    returnFocusAfterClose
  >
    <button type="button" className="ds-drawer__close" onClick={onClose} aria-label="Close">
      <X size={18} aria-hidden />
    </button>
    <div className="ds-drawer__body">{children}</div>
  </Offcanvas>
);

export default Drawer;
